/**
 * French translations for Help Widget System
 * Comprehensive tutorial and help center translations
 */

export const help = {
  // Widget UI
  'help.widget.title': 'Centre d\'aide',
  'help.widget.subtitle': 'Trouvez rapidement les réponses dont vous avez besoin',
  'help.widget.search_placeholder': 'Rechercher dans l\'aide...',
  'help.widget.close': 'Fermer',
  'help.widget.back': 'Retour',
  'help.widget.no_results': 'Aucun résultat trouvé',
  'help.widget.try_different_search': 'Essayez une autre recherche',
  'help.widget.suggested_for_page': 'Suggéré pour cette page',
  'help.widget.quick_actions': 'Actions rapides',
  'help.widget.live_chat': 'Chat en direct',
  'help.widget.video_tutorials': 'Tutoriels vidéo',
  'help.widget.frequent_questions': 'Questions fréquentes',
  'help.widget.footer': 'Besoin d\'aide supplémentaire ? Contactez contact@subvention360.com',

  // Categories
  'help.categories.dashboard': 'Tableau de Bord',
  'help.categories.discovery': 'Découverte',
  'help.categories.search': 'Recherche',
  'help.categories.profile': 'Profil',
  'help.categories.calendar': 'Calendrier',
  'help.categories.organization': 'Organisation',
  'help.categories.all': 'Tous les articles',

  // Dashboard Articles
  'help.articles.getting_started.title': 'Premiers Pas',
  'help.articles.getting_started.description': 'Démarrez rapidement avec Subvention360',
  'help.articles.getting_started.content': 'Bienvenue sur Subvention360 ! Ce guide vous aide à démarrer rapidement. Commencez par compléter votre profil, puis explorez les subventions disponibles.',

  'help.articles.create_profile.title': 'Créer un Profil',
  'help.articles.create_profile.description': 'Créez et gérez vos profils d\'entreprise',
  'help.articles.create_profile.content': 'Un profil complet améliore la précision des recommandations. Renseignez votre SIRET, secteur d\'activité, et informations clés.',

  'help.articles.understanding_dashboard.title': 'Comprendre le Tableau de Bord',
  'help.articles.understanding_dashboard.description': 'Vue d\'ensemble de votre tableau de bord',
  'help.articles.understanding_dashboard.content': 'Le tableau de bord affiche vos statistiques clés, subventions récentes, et actions recommandées.',

  // Discovery Articles
  'help.articles.ai_discovery.title': 'Découverte IA',
  'help.articles.ai_discovery.description': 'Comment l\'IA trouve les aides adaptées',
  'help.articles.ai_discovery.content': 'Notre IA analyse votre profil et recommande automatiquement les subventions les plus pertinentes pour votre entreprise.',

  'help.articles.match_scores.title': 'Scores de Correspondance',
  'help.articles.match_scores.description': 'Comprendre les scores de pertinence',
  'help.articles.match_scores.content': 'Les scores de correspondance (0-100%) indiquent la pertinence d\'une subvention pour votre profil. Plus le score est élevé, meilleure est la correspondance.',

  'help.articles.save_favorites.title': 'Sauvegarder des Favoris',
  'help.articles.save_favorites.description': 'Organisez vos subventions favorites',
  'help.articles.save_favorites.content': 'Cliquez sur l\'icône étoile pour sauvegarder une subvention dans vos favoris et y accéder rapidement.',

  // Search Articles
  'help.articles.search_filters.title': 'Filtres de Recherche',
  'help.articles.search_filters.description': 'Utilisez les filtres pour affiner vos résultats',
  'help.articles.search_filters.content': 'Utilisez les filtres par région, secteur, montant et type de financement pour trouver exactement ce que vous cherchez.',

  'help.articles.save_search.title': 'Sauvegarder une Recherche',
  'help.articles.save_search.description': 'Sauvegardez vos critères de recherche',
  'help.articles.save_search.content': 'Sauvegardez vos filtres de recherche favoris pour les réutiliser rapidement et recevoir des alertes sur les nouvelles opportunités.',

  'help.articles.export_results.title': 'Exporter les Résultats',
  'help.articles.export_results.description': 'Exportez vos données en CSV ou PDF',
  'help.articles.export_results.content': 'Exportez vos résultats de recherche en format CSV ou PDF pour les partager avec votre équipe ou les analyser hors ligne.',

  // Profile Articles
  'help.articles.siret_guide.title': 'Guide SIRET',
  'help.articles.siret_guide.description': 'Tout savoir sur le numéro SIRET',
  'help.articles.siret_guide.content': 'Le SIRET est votre identifiant unique d\'entreprise en France. Il contient 14 chiffres et permet de récupérer automatiquement vos données officielles.',

  'help.articles.profile_best_practices.title': 'Bonnes Pratiques de Profil',
  'help.articles.profile_best_practices.description': 'Optimisez votre profil pour de meilleurs résultats',
  'help.articles.profile_best_practices.content': 'Un profil détaillé et à jour garantit des recommandations précises. Mettez à jour régulièrement vos informations et activités.',

  // Calendar Articles
  'help.articles.calendar_guide.title': 'Guide du Calendrier',
  'help.articles.calendar_guide.description': 'Gérez vos échéances de candidature',
  'help.articles.calendar_guide.content': 'Le calendrier affiche toutes vos échéances de candidature. Configurez des rappels pour ne jamais manquer une date limite.',

  // Alias for calendar (used in useContextualHelp)
  'help.articles.calendar.title': 'Calendrier des échéances',
  'help.articles.calendar.description': 'Ne manquez aucune deadline importante',

  'help.articles.notifications.title': 'Notifications',
  'help.articles.notifications.description': 'Configurez vos alertes et notifications',
  'help.articles.notifications.content': 'Recevez des notifications par email pour les nouvelles opportunités, échéances proches, et mises à jour importantes.',

  // Organization Articles
  'help.articles.team_collaboration.title': 'Collaboration d\'Équipe',
  'help.articles.team_collaboration.description': 'Travaillez en équipe sur vos candidatures',
  'help.articles.team_collaboration.content': 'Invitez des membres de votre équipe, assignez des rôles, et collaborez efficacement sur vos dossiers de subvention.',

  'help.articles.organization_roles.title': 'Rôles d\'Organisation',
  'help.articles.organization_roles.description': 'Gérez les permissions de votre équipe',
  'help.articles.organization_roles.content': 'Définissez des rôles (Admin, Membre, Lecteur) pour contrôler les accès et permissions de votre équipe.',

  // Fallback Articles
  'help.articles.faq.title': 'Questions Fréquentes',
  'help.articles.faq.description': 'Réponses aux questions courantes',
  'help.articles.faq.content': 'Consultez nos réponses aux questions les plus fréquemment posées par nos utilisateurs.',

  'help.articles.contact_support.title': 'Contacter le Support',
  'help.articles.contact_support.description': 'Besoin d\'aide supplémentaire ?',
  'help.articles.contact_support.content': 'Notre équipe support est disponible pour vous aider. Contactez-nous par email à contact@subvention360.com ou via le chat en direct.',

  // Alias for contact (used in useContextualHelp)
  'help.articles.contact.title': 'Contacter le support',
  'help.articles.contact.description': 'Obtenez de l\'aide de notre équipe d\'experts',

  'help.articles.video_tutorials.title': 'Tutoriels Vidéo',
  'help.articles.video_tutorials.description': 'Apprenez en regardant nos vidéos',
  'help.articles.video_tutorials.content': 'Découvrez nos tutoriels vidéo pour apprendre visuellement à utiliser toutes les fonctionnalités de la plateforme.',

  // Alias for videos (used in useContextualHelp)
  'help.articles.videos.title': 'Tutoriels vidéo',
  'help.articles.videos.description': 'Apprenez avec nos guides vidéo étape par étape',

  // Quick Actions
  'help.quick_actions.live_chat': 'Chat en Direct',
  'help.quick_actions.video_tutorials': 'Tutoriels Vidéo',
  'help.quick_actions.contact_support': 'Contacter le Support',
  'help.quick_actions.view_faq': 'Voir la FAQ',

  // Error Messages
  'help.error.load_failed': 'Impossible de charger l\'aide',
  'help.error.retry': 'Réessayer',
  'help.error.article_not_found': 'Article non trouvé',

  // Additional UI Elements
  'help.read_more': 'Lire plus',
  'help.related_articles': 'Articles connexes',
  'help.was_helpful': 'Cet article vous a-t-il été utile ?',
  'help.yes': 'Oui',
  'help.no': 'Non',
  'help.thank_you': 'Merci pour votre retour !',
} as const;
